import { WAITLIST_DEPOSIT_GBP } from '../../types/waitlist';

/**
 * Waitlist copy, including the deposit. OWNER DECISION PENDING on the deposit
 * terms: the wording below assumes the amount is a DEPOSIT — credited against
 * the first membership payment and refunded in full if Melio cannot offer a
 * place. If it is a non-refundable reservation fee instead, change `terms`
 * here and the matching sentence in the privacy addendum
 * (src/legal/privacy.ts). The Terms of Service do not yet mention the deposit
 * at all; that is a controlled document and needs the owner's revision.
 */
export const WAITLIST_DEPOSIT = {
  amountGbp: WAITLIST_DEPOSIT_GBP,
  amountLabel: `£${WAITLIST_DEPOSIT_GBP}`,
  heading: 'Reserve your place',
  label: 'Reserve your place',
  terms:
    `A £${WAITLIST_DEPOSIT_GBP} deposit holds your place on the list. It is credited against your first membership payment and refunded in full if we cannot offer you a place.`,
  processing: 'Payment is taken securely by Stripe. We never see or store your card details.',
  busy: 'Taking you to payment…',
} as const;

export const WAITLIST_COPY = {
  body: `We haven't opened to new members yet. Leave your name and reserve your place with a £${WAITLIST_DEPOSIT_GBP} deposit, and we'll write to you before anyone else when we do.`,
  bodyForInterest: (assessment: string) =>
    `We haven't opened to new members yet. Leave your name and reserve your place with a £${WAITLIST_DEPOSIT_GBP} deposit, and we'll write to you before anyone else when the ${assessment} opens.`,
  cancelled: 'Your details are saved, but your place is not reserved until the deposit is paid.',
  resume: 'Complete your reservation',
  onTheList: "You're on the list",
  reserved: 'Your place is reserved',
} as const;

export const WAITLIST_THANK_YOU = {
  title: 'Your place is reserved.',
  body: `Thank you. Your £${WAITLIST_DEPOSIT_GBP} deposit is held against your membership, and we'll write to you before anyone else when we open to new members.`,
  confirming: 'Confirming your payment…',
  failedTitle: 'We could not confirm that payment.',
  failedBody:
    'If your bank shows the payment as taken, your place is safe—Stripe tells us directly and we reconcile every payment. If not, you can try again from the waitlist page.',
  detailsIntro: 'Four optional questions while you are here. They help us decide where and when to open and what to staff for first.',
  testMode: 'Test mode: no payment was taken on this environment.',
} as const;
